import * as React from "react";

import { createHocDisplayName } from "./TypingUtils";
import { useDisabledProperty } from "./Services/Contexts/DisabledPropertyContext";
import { EvaluableProp } from "./withEvaluators";

export function withDisabledByParent<P extends { disabled2?: EvaluableProp<boolean> }>(
    WrappedComponent: React.NamedExoticComponent<P> | React.ComponentType<P>
): React.ComponentType<P> {
    function DisabledByParentWrapper(props: P): JSX.Element {
        const disabled = useDisabledProperty();

        return <WrappedComponent {...props} disabled2={disabled || props.disabled2} />;
    }
    DisabledByParentWrapper.displayName = createHocDisplayName(WrappedComponent, "DisabledByParent");
    return DisabledByParentWrapper;
}
